<template>
  <a
    :href="url"
    class="tw-text-xs tw-font-medium !tw-text-deep-orange-500 hover:!tw-text-deep-orange-500"
    :data-testid="trackingId"
    :target="newTab ? '_blank' : '_self'"
    :rel="newTab ? 'noopener noreferrer' : undefined"
    @click="$emit('click')"
  >
    <slot />
  </a>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StudioLink',
  props: {
    url: {
      type: String,
      required: true
    },
    trackingId: {
      type: String,
      required: true
    },
    newTab: {
      type: Boolean,
      default: false
    }
  }
});
</script>
